import { CompanyDepositSettings } from '../modules/scheduling/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';

export function CompanySchedulingSettingsScreen() {
  const { can, company } = useCompanyScope();
  return (
    <GatedCompanyScreen allowed={can('scheduling.settings.manage')}>
      <CompanyDepositSettings
        units={company.businessUnits ?? []}
        salesContracted={company.moduleKeys.includes('sales')}
      />
    </GatedCompanyScreen>
  );
}
